import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import CardHeader from "@mui/material/CardHeader";
import Grid from "@mui/material/Grid";
import React from "react";
import Typography from "@mui/material/Typography";
import { ISailDimension } from "../declarations";
import { useGetSailInfoSizing } from "../hooks/useGetSailInfoSizing";

type SailInfoSizingProps = {
    guid: string;
};

const SailInfoSizing: React.FC<SailInfoSizingProps> = ({ guid }) => {
    const { data, isLoading } = useGetSailInfoSizing(guid);

    if (isLoading || !data) {
        return null;
    }

    return (
        <Card sx={{ width: "100%" }}>
            <CardHeader title="Sizing" />
            <CardContent>
                <Grid container spacing={2}>
                    {data.map((item: ISailDimension, index: number) => {
                        if (item.render === false) return null;
                        return (
                            <React.Fragment key={index}>
                                <Grid size={6}>
                                    <Typography variant="caption">
                                        {" "}
                                        {item.msm}
                                    </Typography>
                                </Grid>
                                <Grid size={6}>
                                    <Typography variant="body1">
                                        {" "}
                                        {item.designValue}{" "}
                                        {item.msm === "Area" ? "sq m" : "mm"}
                                    </Typography>
                                </Grid>
                            </React.Fragment>
                        );
                    })}
                </Grid>
            </CardContent>
        </Card>
    );
};

export default SailInfoSizing;
